<!-- Number Input for Inspector -->
<script lang="ts">
  import Input from '@/ui/base/Input.svelte';

  let {
    value = $bindable(0),
    min,
    max,
    onChange,
  }: {
    value: number;
    min?: number;
    max?: number;
    onChange?: (value: number) => void;
  } = $props();

  function handleChange(newValue: string | number) {
    let numValue = typeof newValue === 'string' ? parseFloat(newValue) : newValue;

    // Apply constraints
    if (min !== undefined && numValue < min) numValue = min;
    if (max !== undefined && numValue > max) numValue = max;

    value = numValue || 0;
    onChange?.(value);
  }
</script>

<Input type="number" {value} onChange={handleChange} extraClass="text-xs" />
